
const {
  GET_LIST_SUPPORT,
  GET_LIST_SUPPORT_MESSAGE,
  UPSERT_SUPPORT,
  UPSERT_SUPPORT_MESSAGE,
  GET_LIST_SUPPORT_SUCCESS,
  UPSERT_SUPPORT_SUCCESS,
  GET_LIST_SUPPORT_MESSAGE_SUCCESS,
  UPSERT_SUPPORT_MESSAGE_SUCCESS,
  GET_LIST_SUPPORT_FAIL,
  GET_LIST_SUPPORT_MESSAGE_FAIL,
  UPSERT_SUPPORT_MESSAGE_FAIL,
  RESET_SUPPORT_FLAG,
  CLOSED_SUPPORT,
  CLOSED_SUPPORT_FAIL,
  CLOSED_SUPPORT_SUCCESS,
  SWITCH_SUPPORT,
  SWITCH_SUPPORT_SUCCESS,
  SWITCH_SUPPORT_FAIL,
  ADD_SUPPORT_FILE,
  ADD_SUPPORT_FILE_SUCCESS,
  ADD_SUPPORT_FILE_FAIL,
  GET_SUPPORT_FILES,
  GET_SUPPORT_FILES_SUCCESS,
  GET_SUPPORT_FILES_FAIL,
  DELETE_SUPPORT_FILE,
  DELETE_SUPPORT_FILE_SUCCESS,
  DELETE_SUPPORT_FILE_FAIL,
  UPSERT_SUPPORT_FAIL,
} = require("./actionTypes")

const INIT_STATE = {
  lstSupport: [],
  lstSupportFiles: [],
  lstSupportMessage: [],
  error: null,
  success: null,
  loading: false,
  triggerReload: 0,
}

const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_LIST_SUPPORT:
    case GET_LIST_SUPPORT_MESSAGE:
    case UPSERT_SUPPORT:
    case UPSERT_SUPPORT_MESSAGE:
    case CLOSED_SUPPORT:
    case SWITCH_SUPPORT:
    case ADD_SUPPORT_FILE:
    case GET_SUPPORT_FILES:
    case DELETE_SUPPORT_FILE:
      return {
        ...state,
        loading: true,
      }

    case DELETE_SUPPORT_FILE_SUCCESS:
      return {
        ...state,
        error: null,
        loading: false,
        success: "فایل با موفقیت حذف شد",
        lstSupportFiles: state.lstSupportFiles.filter(
          file => file.id !== action.payload.id
        ),
      }

    case GET_LIST_SUPPORT_SUCCESS:
      return {
        ...state,
        lstSupport: action.payload,
        loading: false,
        success: null,
        error: null,
      }

    case UPSERT_SUPPORT_SUCCESS:
      const { message: supportMessage, newSupport } = action.payload || {}
      return {
        ...state,
        loading: false,
        lstSupport: [newSupport, ...state.lstSupport],
        success: supportMessage || action.payload,
      }
    case CLOSED_SUPPORT_SUCCESS:
      const { id: closedId, updatedSupport: closedSupport } =
        action.payload || {}

      if (closedSupport) {
        // Update specific support in both lists
        const updatedSupportList = state.lstSupport.map(support =>
          support.id === closedId ? { ...support, ...closedSupport } : support
        )

        const updatedMessageList = state.lstSupportMessage.map(item =>
          item.support?.id === closedId
            ? { ...item, support: { ...item.support, ...closedSupport } }
            : item
        )

        return {
          ...state,
          loading: false,
          success: "وضعیت تیکت تغییر کرد",
          error: null,
          lstSupport: updatedSupportList,
          lstSupportMessage: updatedMessageList,
        }
      }

      return {
        ...state,
        loading: false,
        success: "انجام شد",
        error: null,
        triggerReload: state.triggerReload + 1,
      }

    case SWITCH_SUPPORT_SUCCESS:
      const { supportId, updatedSupport: switchedSupport } =
        action.payload || {}

      if (switchedSupport) {
        // Remove from current user's list as it's switched to another user
        const filteredSupportList = state.lstSupport.filter(
          support => support.id !== supportId
        )

        return {
          ...state,
          loading: false,
          success: "تیکت ارجاع داده شد",
          error: null,
          lstSupport: filteredSupportList,
        }
      }

      return {
        ...state,
        loading: false,
        success: "انجام شد",
        error: null,
        triggerReload: state.triggerReload + 1,
      }
    case GET_LIST_SUPPORT_MESSAGE_SUCCESS:
      return {
        ...state,
        lstSupportMessage: action.payload,
        loading: false,
        success: null,
        error: null,
      }

    case UPSERT_SUPPORT_MESSAGE_SUCCESS:
      const { message: ticketMessage, newSupportMessage } = action.payload || {}

      if (newSupportMessage) {
        // Add new item to the list
        return {
          ...state,
          loading: false,
          success: ticketMessage,
          lstSupportMessage: [...state.lstSupportMessage, newSupportMessage],
        }
      }

      return {
        ...state,
        loading: false,
        success: ticketMessage || action.payload,
      }

    case ADD_SUPPORT_FILE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: "فایل با موفقیت بارگذاری شد",
        error: null,
      }

    case GET_SUPPORT_FILES_SUCCESS:
      return {
        ...state,
        loading: false,
        lstSupportFiles: action.payload,
        success: "فایلها بارگذاری شدند",
        error: null,
      }

    case GET_LIST_SUPPORT_FAIL:
    case GET_LIST_SUPPORT_MESSAGE_FAIL:
    case UPSERT_SUPPORT_MESSAGE_FAIL:
    case CLOSED_SUPPORT_FAIL:
    case SWITCH_SUPPORT_FAIL:
    case ADD_SUPPORT_FILE_FAIL:
    case GET_SUPPORT_FILES_FAIL:
    case DELETE_SUPPORT_FILE_FAIL:
    case UPSERT_SUPPORT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload ? action.payload : "خطای پیش بینی نشده",
        success: "",
      }

    case RESET_SUPPORT_FLAG:
      return {
        ...state,
        success: null,
        error: null,
        triggerReload: 0,
      }

    default:
      return state
  }
}

export default reducer
